<template>
  <div>
    <div
      v-if="show"
      @mouseover="mouseover"
      @mouseout="mouseout"
      class="box"
      :style="{ top: top + 'px', left: left + 'px' }"
    >
      <span @click="close">
        关闭
      </span>
	  </br>
      <div >
        <img :src="require('../assets/img/wmcsxc.jpg')"  fit="scale-down"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slogan',
  props: {
    content: {
      default: '',
    },
  },
  data() {
    return {
      show: true,
      stepX: 1,
      stepY: 1,
      timer: null,
      maxTop: 0,
      maxLeft: 0,
      top: 0,
      left: 0,
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer)
  },
  methods: {
    init() {
      this.maxTop = document.documentElement.clientHeight - 220 - 5
      this.maxLeft = document.documentElement.clientWidth - 200 - 5
      this.top = 0
      this.left = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)
      this.onresize()
    },

    // 移动函数

    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX
      }
      this.top += this.stepY
      this.left += this.stepX
    },

    mouseover() {
      clearInterval(this.timer)
    },

    mouseout() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)
    },

    close() {
      clearInterval(this.timer)
      this.show = false
    },

    onresize() {
      const that = this
      window.onresize = function () {
        that.init()
      }
    },
  },
}
</script>

<style scoped>
.box {
  position: fixed;

  //color: #ffffff;
  top: 0;
  left: 0;
  z-index: 999999;
}
.box > span {
  text-align: right;
  position: absolute;
  color: #ff0000;
  cursor: pointer;
}
.box img{
  width: 350px;
  height: 150px;
}
/*.box > div {
  margin-top: 30px;
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
}*/
</style>
